import axios from 'axios'

export default {
    getLevelQuestions(level) {
        return axios.get('/api/level-test/questions', {
            params: {
                level: level
            }
        })
    },

    levelTestFinished(level) {
        return axios.post('/level-test/finished', {level: level})
    }
}
